import { Component, EventEmitter, Input, OnInit, Output, ViewChild } from '@angular/core';
import { FormArray, FormBuilder, FormGroup, Validators } from '@angular/forms';
import { GobalFunctionService } from 'src/app/core/services/gobal/gobal-function.service';
import { PlyrComponent } from 'ngx-plyr';

@Component({
  selector: 'lifedi-multiple-choice',
  templateUrl: './multiple-choice.component.html',
  styleUrls: ['./multiple-choice.component.scss']
})
export class MultipleChoiceComponent implements OnInit {

  @Input() measureForm: FormGroup;
  @Input() multipleChoice;
  @Input() isAutoNumber: boolean = true;
  @Input() questionNumber: number;
  @Input() type: string;
  @Input() font: string;
  @Output() progressVal = new EventEmitter<Number>();

  @ViewChild(PlyrComponent)

  plyr: PlyrComponent;
  player: Plyr;

  videoSources: Plyr.Source[] = [];

  extensionQuestion;
  media;
  choice;
  videoBtnStatus: boolean = true;
  audioBtnStatus: boolean = true;
  time_again: number;
  vdoCurrentTime;
  unlimit: boolean;
  audCurrentTime: number = 0;

  multipleForm;
  countProgress: number = 1;
  countAnswers: number = 0;
  done: boolean = false;

  constructor(
    private fb: FormBuilder,
    private gbFunction: GobalFunctionService,
  ) { }

  get answers(): FormArray {
    if (this.measureForm) {
      return this.measureForm.controls['DATA'] as FormArray;
    }
  }

  ngOnInit(): void {

    this.time_again = this.multipleChoice.VALUE[0].media.time_again ? parseInt(this.multipleChoice.VALUE[0].media.time_again) : 0;
    this.unlimit = this.multipleChoice.VALUE[0].media.unlimit ? true : false;

    if (this.multipleChoice.VALUE[0].media.file_url) {
      this.videoSources.push({
        src: this.multipleChoice.VALUE[0].media.vdo_id,
        provider: 'vimeo',
      })
    }

    if (this.type === 'measure') {
      this.multipleForm = this.fb.group({
        ID: [this.multipleChoice.ID, Validators.required],
        ANSWER: ['', Validators.required]
      });
      this.answers.push(this.multipleForm);

    } else if (this.type === 'research') {
      this.multipleForm = this.fb.group({
        ID: [this.multipleChoice.ID, Validators.required],
        ANSWER: ['']
      });
      this.answers.push(this.multipleForm);
    } else {
      this.done = true;
    }

  }

  playAudio(au) {
    let audioPlayer = <HTMLVideoElement>document.getElementById(au);
    audioPlayer.play();
    this.audioBtnStatus = false;

    this.time_again = this.time_again - 1;
  }

  played(event: Plyr.PlyrEvent) {
    // // console.log('played', event);
    // document.getElementById('vdototaltime').innerHTML = this.player.duration;
  }

  playVideo(): void {
    this.player.play();
    this.videoBtnStatus = false;
    this.time_again = this.time_again - 1;
  }

  vdoEnable(loop): void {
    if (loop === 0) {
      this.videoBtnStatus = false;
    } else {
      this.videoBtnStatus = true;
    }

  }

  auEnable(loop): void {
    if (loop === 0) {
      this.audioBtnStatus = false;
    } else {
      this.audioBtnStatus = true;
    }
  }

  currentvdoTime() {
    this.vdoCurrentTime = this.player.currentTime / 100;
  }

  currentaudTime(au) {
    var audio = <HTMLVideoElement>document.getElementById(au);
    this.audCurrentTime = audio.currentTime / 100;
  }

  patchVal(choice) {
    this.multipleForm.patchValue({
      ANSWER: choice
    });
    this.multipleForm.updateValueAndValidity();
    this.progress(this.multipleForm);
  }

  progress(form) {

    if (form.status === 'VALID') {
      this.done = true;
    } else if (form.status === 'INVALID') {
      this.done = false;
    }

    if (form.status === 'VALID' && this.countAnswers === 0) {
      this.countAnswers = 1;

      if (this.countAnswers === 1) {
        this.countProgress = 2;
        this.progressVal.emit(this.countProgress);
      }

    } else if (form.status === 'INVALID' && this.countProgress === 2) {
      this.countProgress = 0;
      this.countAnswers = 0;
      this.progressVal.emit(this.countProgress);
    }
  }

}
